import createEn from "./en.json";
import createTr from "./tr.json";

export const CREATE_DICTIONARIES: Record<"tr" | "en", Record<string, string>> = {
    en: createEn,
    tr: createTr
};
